<script>
export default {
  name: 'RatioContainer',
  functional: true,
  props: {
    ratio: {
      type: Number,
      default: 46.73,
    },
  },
};
</script>

<template lang="pug" functional>
div.ratio-container(:style="{paddingTop: `${props.ratio}%`}")
  div
    slot

</template>

<style scoped>

.ratio-container {
  width: 100%;
  position: relative;
  & > div {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
  }
}

</style>
